<script>
import { onMount } from "svelte";


    let i = 0;
    const txt = 'I like to make stuff with code';
    const speed = 40;

    let root;

    onMount(() => {
        typeWriter();
    });

    function typeWriter() {
    if (i < txt.length) {
        root.querySelector("#typewriter").innerHTML += txt.charAt(i);
        i++;
        setTimeout(typeWriter, speed);
    }
}
</script>

<div class="flex font-normal font-barlow lg:items-center" bind:this={root}>
    <div class="text-center">
        <div class="my-5">
            <h1 class="text-5xl">Hello</h1>
            <p id="typewriter" class="text-xl font-bold place-self-center"></p>
        </div>
        <div class="my-5 mx-5 md:mx-10">
            <p>
                I'm a CS student from The Netherlands who loves to code. 
                I have recently started dabbling in the frontend, and fell in love with it. This portfolio website is my first project. 
                I will be sharing my other projects and coding stuff on here for you to take a look at. I will be making lots of cool
                projects, so I can grow my coding skills and solidify some concepts. 
                They can be found on the "Projects" page, where you can also grab the link to the Github repo to take a look at the code. 
                Go ahead and take a look! Oh and thanks for visiting!
            </p>
        </div>
        <p class="text-md font-thin">This website is a WIP. Please report any bugs to me on Twitter.</p>
        <p class="mt-5 text-sm">Made with Svelte and Tailwind CSS</p>
        <a class="text-blue-500 text-xs" href="https://www.vecteezy.com/free-vector/social-media" target="_blank">Social Media Vectors by Vecteezy</a>
    </div>

</div>          